import React, { useState } from "react";
import { Button, Icon, Input, Typography } from "@plum-xoxo/admin-dsm";

import styled from "styled-components";

const StyledInput = styled(Input)`
  margin-bottom: 10px;
  div > div > input {
    background-color: ${(props) => props.theme.palette.light.c000};
    border-radius: 4px 0px 0px 4px;
  }
  .eui-input-right {
    background-color: ${(props) => props.theme.palette.light.c000};
    padding: 14px;
    border-radius: 0px 4px 4px 0px;
  }
`;

const StyledIcon = styled(Icon)``;

const data = [
  {
    key: "charater",
    icon: "Right",
    content: "Must have at least 8 characters.",
  },
  {
    icon: "Right",
    content: "Must contain a number.",
    key: "number",
  },
  {
    icon: "Right",
    content: "Must contain at least one special character.",
    key: "special",
  },
];

const Password = ({ password, setPassword, setCurrentStep }) => {
  const [showPassword, setShowPassword] = useState(false);
  const [validPassword, setValidPassword] = useState(true);

  const [passwordError, setPasswordError] = useState({
    charater: false,
    number: false,
    special: false,
    maxLength: false,
  });

  const handlePassword = (value) => {
    let obj = {
      charater: false,
      number: false,
      special: false,
      maxLength: false,
    };
    setPassword(value);
    var reg = new RegExp(
      "^(?!.* )(?=.*[0-9])(?=.*[$&+,:;=?@#|'<>.^*()%!-])(?=.{8,})"
    );
    const numberRegex = new RegExp("^(?!.* )(?=.*[0-9])");
    const specialRegex = new RegExp("^(?!.* )(?=.*[$&+,:;=?@#|'<>.^*()%!-])");
    const characterRegex = new RegExp("^(?!.* )(?=.{8,})");
    !characterRegex.test(value)
      ? (obj["charater"] = false)
      : (obj["charater"] = true);
    !numberRegex.test(value) ? (obj["number"] = false) : (obj["number"] = true);
    !specialRegex.test(value)
      ? (obj["special"] = false)
      : (obj["special"] = true);
    if (value && value.length > 100) obj["maxLength"] = true;
    setPasswordError({ ...obj });
    if (!reg.test(value)) setValidPassword(false);
    else setValidPassword(true);
  };

  const updatePassword = () => {
    setCurrentStep(3);
  };
  return (
    <div className="d-flex flex-column gap-16 w-100">
      <div>
        <Typography.BodySmall className="mb-4">
          Step 2 of 3
        </Typography.BodySmall>
        <Typography.H1 className="mb-4">Set your password</Typography.H1>
        <Typography.BodySmall className="mb-4">
          Complete creating your account by setting a password.
        </Typography.BodySmall>
      </div>
      <StyledInput
        value={password}
        onChange={(e) => {
          handlePassword(e.target.value);
        }}
        onKeyDown={(e) => {
          if (e.key === "Enter") updatePassword();
        }}
        type={showPassword ? "text" : "Password"}
        placeholder="Set a password"
        endIcon={
          <>
            {password ? (
              <Typography.HelperText
                className="cursor-pointer"
                color="primary"
                shade="c02"
                variant="plain"
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? "Hide" : "Show"}
              </Typography.HelperText>
            ) : (
              <Typography.HelperText className="py-10">
                {null}
              </Typography.HelperText>
            )}
          </>
        }
      />
      <div className="d-flex gap-20 flex-column mt-4">
        {data.map((item, index) => (
          <div key={index} className="d-flex gap-8 align-items-center">
            <StyledIcon
              iconName={item.icon}
              size={16}
              color={passwordError[item.key] ? "green" : "dark"}
              shade={passwordError[item.key] ? "c300" : "c200"}
            />
            <Typography.BodySmall
              color={passwordError[item.key] ? "green" : "dark"}
              shade={passwordError[item.key] ? "c300" : "c200"}
              className="d-flex align-items-center mb-0"
            >
              {item.content}
            </Typography.BodySmall>
          </div>
        ))}
      </div>

      {passwordError && passwordError.maxLength && (
        <Typography.BodySmall color="red" shade="c200" className="mb-4">
          Password should be less than 100 characters
        </Typography.BodySmall>
      )}

      <Button
        className="w-100 mt-12"
        size={"large"}
        disabled={!password || !validPassword}
        onClick={updatePassword}
        endIcon={<Icon iconName="RightArrow" color="white" />}
      >
        Continue
      </Button>
    </div>
  );
};

export default Password;
